import { normalizeSelectQuestionType } from "./selectOtherOption";

type MultiSelectQuestionLike = {
  questionType?: unknown;
  options?: Record<string, unknown> | null;
};

export const MULTI_SELECT_MAX_SELECTIONS_OPTION = "maxSelections";

export function getMultiSelectMaxSelections(
  question: MultiSelectQuestionLike,
): number | null {
  if (normalizeSelectQuestionType(question.questionType) !== "multi-select") {
    return null;
  }

  const options = question.options || {};
  const raw =
    options[MULTI_SELECT_MAX_SELECTIONS_OPTION] ?? options.maxSelection;
  const numeric =
    typeof raw === "number"
      ? raw
      : typeof raw === "string" && raw.trim()
        ? Number(raw)
        : Number.NaN;

  if (!Number.isFinite(numeric)) return null;

  const maxSelections = Math.floor(numeric);
  return maxSelections > 0 ? maxSelections : null;
}
